import Reflux from "reflux";
import Actions from "../../Actions";
import logger from "../../utils/LoggerFrontend";
import { t } from "i18next";
import { ActionsProfile } from "../../Actions/ActionsProfile/ActionsProfile";

const fallbackTable = [
  {
    id: 1,
    title: "N/A",
    team: "N/A"
  },
  {
    id: 2,
    title: "N/A",
    team: "N/A"
  }
];

const INITIAL_PROFILE = {
  requirements: [],
  chatbotQuestions: []
};

export default class ProfilesStore extends Reflux.Store {
  constructor() {
    super();

    this.state = {
      profiles: [],
      profile: INITIAL_PROFILE,
      profileMeta: "initial",
      isLoadingProfiles: false,
      isLoadingCategories: false,
      domainSkills: [],
      categories: []
    };

    this.listenables = ActionsProfile;
    this.onError = this.onError.bind(this);
  }

  onError(error) {
    this.setState({ error });
  }

  // all profiles
  onGetProfilesByOrganizationId() {
    this.setState({ isLoadingProfiles: true });
  }

  onGetProfilesByOrganizationIdCompleted({ payload }) {
    logger.log("ProfileStore:getProfilesByOrganizationId", "received profiles", payload);
    this.setState({ isLoadingProfiles: false, profiles: payload });
  }

  onGetProfilesByOrganizationIdFailed(error) {
    logger.log("error:ProfileStore:getProfilesByOrganizationId", "get profiles failed", error);
    this.setState({ isLoadingProfiles: false, profiles: fallbackTable });
  }

  // Single profile
  onCreateProfileCompleted({ payload }) {
    logger.log("ProfileStore:onCreateProfileCompleted", "create profile successfully", payload);

    this.setState({ profiles: [...this.state.profiles, payload] });
    Actions.addNotification(t("Profile created"));
  }

  onCreateProfileFailed(error) {
    logger.log("error:ProfileStore:onCreateProfileFailed", "create profile failed", error);
    Actions.addNotification(t("Profile could not be created"), "error");
  }

  onGetProfileByOrganizationIdCompleted({ payload }) {
    logger.log("ProfileStore:getProfileByOrganizationId", "received profile", payload);
    this.setState({ profile: payload, profileMeta: "loaded" });
  }

  onGetProfileByOrganizationIdFailed(error) {
    logger.log("error:ProfileStore:getProfileByOrganizationId", "get profile failed", error);
    this.setState({ profile: INITIAL_PROFILE, profileMeta: "failed" });
  }

  onPatchProfileCompleted({ payload }) {
    logger.log("ProfileStore:patchProfileCompleted", "update profile completed", payload);
    this.setState({ profile: payload });
  }

  onPatchProfileFailed(error) {
    logger.log("error:ProfileStore:patchProfileFailed", "update profile failed", error);
  }

  onGetCategoriesByJobCategoryIdCompleted({ payload }) {
    const categories = (payload || []).map((item) => {
      return {
        categoryId: item.id,
        name: item.name,
        type: item.type,
        domainSkills: item.domainSkills.map((skill) => ({
          id: skill.categoryId,
          name: skill.name,
          isSelected: false
        }))
      };
    });

    logger.log("ProfileStore:onGetCategoriesByJobCategoryIdCompleted", "get categories completed", {
      payload,
      categories
    });

    this.setState({ categories, isLoadingCategories: false });
  }

  onGetCategoriesByJobCategoryIdFailed() {
    Actions.addNotification(t("Error fetching domain skills"), "error");

    this.setState({ isLoadingCategories: false });
  }

  onGetDomainSkillsByJobCategoryIdCompleted({ payload }) {
    logger.log(
      "ProfileStore:onGetDomainSkillsByJobCategoryIdCompleted",
      "get domain skills completed",
      payload
    );

    this.setState({ domainSkills: payload?.domainSkills || [] });
  }

  onCreateDomainSkillCompleted() {
    Actions.addNotification(t("Domain skill created successfully"));
  }

  onCreateDomainSkillFailed({ responseJSON }) {
    logger.log(
      "error:ProfileStore:onCreateDomainSkillFailed",
      "failed to create domain skill",
      responseJSON
    );

    let errorMessage;

    try {
      if (typeof responseJSON.payload === "string") {
        errorMessage = responseJSON.payload;
      } else if (Array.isArray(responseJSON.payload)) {
        // Extract field and message from each error object
        const errorMessages = responseJSON.payload.map((error) => {
          if (error.field && error.message) {
            return `${error.field}: ${error.message}`;
          }
          return error.message || error.field || JSON.stringify(error);
        });

        errorMessage = errorMessages.join("; ");
      } else {
        errorMessage = t("An error occurred. Please try again.");
      }
    } catch (e) {
      logger.error("Error parsing error response:", e);
      errorMessage = t("An error occurred. Please try again.");
    }

    Actions.addNotification(errorMessage, "error");
  }

  onGenerateWhatsappFormCompleted({ payload }) {
    logger.log("ProfileStore:generateWhatsappForm", "whatsapp form generated", payload);
    Actions.addNotification(t("Generating Whatsapp form."));
  }

  onGenerateWhatsappFormFailed(error) {
    logger.log("error:ProfileStore:generateWhatsappForm", "generate whatsapp form failed", error);
    Actions.addNotification(t("Error while generating Whatsapp form"), "error");
  }

  onDeleteProfileCompleted() {
    Actions.addNotification(t("Profile deleted"));
  }

  filterProfileById(deletedProfileId) {
    const updatedProfiles = (this.state.profiles || []).filter(
      (profile) => profile.id !== deletedProfileId
    );
    this.setState({ profiles: updatedProfiles });
  }
}
